// Module
var code = "<file-field v-if=\"form\" :disabled=\"disabled\" :label=\"label ? label : name\" :value.sync=\"form[field]\" :validation=\"form.validation[field]\"><slot>{{ label || name }}</slot></file-field> ";
// Exports
export default code;